import { alpha, Theme } from '@mui/material/styles'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const componentsOverride = (theme: Theme) => ({
    MuiAppBar: {
        styleOverrides: {
            root: {
                backgroundColor: theme.palette.primary.main,
            },
        },
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                color: theme.palette.text.primary,
            },
            shrink: {
                color: theme.palette.text.disabled,
            },
        },
    },
    MuiSelect: {
        defaultProps: {
            variant: 'standard',
        },
        styleOverrides: {
            icon: {
                backgroundColor: alpha('#FFFFFF', 0.09),
            },
        },
    },
    MuiToolbar: {
        styleOverrides: {
            dense: {
                height: '50px',
                minHeight: '50px',
                [theme.breakpoints.up('sm')]: {
                    minHeight: '50px',
                },
            },
        },
    },
    MuiBreadcrumbs: {
        styleOverrides: {
            root: {
                color: theme.palette.text.primary,
            },
        },
    },
    MuiDialog: {
        styleOverrides: {
            paperFullWidth: {
                padding: '20px 30px 15px',
                gap: theme.spacing(1.25),
            },
        },
    },
    MuiDialogTitle: {
        defaultProps: {
            component: 'div',
        },
        styleOverrides: {
            root: {
                padding: 'unset',
            },
        },
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                padding: 'unset',
            },
        },
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: `${theme.spacing(1.25)} 0`,
            },
        },
    },
    MuiButton: {
        variants: [
            {
                props: { variant: 'link' },
                style: {
                    textTransform: 'none',
                    textDecoration: 'underline',
                    padding: '0 1px 2px 1px',
                    '&.MuiButtonBase-root:hover': {
                        color: theme.palette.primary.main,
                        backgroundColor: 'transparent',
                        textDecoration: 'underline',
                    },
                },
            },
        ],
    },
    MuiPickersToolbar: {
        styleOverrides: {
            root: {
                paddingBottom: 0,
                display: 'none',
            },
            content: {
                display: 'none',
            },
        },
    },
})

export { componentsOverride }
